export function menuOld() {

    $(".desktop_nav_bar__item--expandable>a").on('click', function (e) {
        e.preventDefault();
        let pointer = $(".desktop_sub_bar__pointer"),
            active_submenu = $(".submenu.active");
        pointer.css('left', ($(this).offset().left + $(this).outerWidth() / 2) + "px");
        if (active_submenu.length) {
            let $that = $(this),
                current = $(this).hasClass("active");

            active_submenu.removeClass("active");
            active_submenu.parent().find('a').removeClass("active");

            if (!current) {
                setTimeout(function () {
                    $that.trigger('click');
                }, 300);
            }
            else {
                pointer.css('left', "-20px");
                $(".desktop_sub_bar").removeClass("active");
                $that.on('mouseleave', function () {
                    $that.blur();
                    $that.unbind('mouseleave');
                })
            }

        } else {
            $(this).addClass('active');
            $(".desktop_sub_bar").addClass("active");
            $(this).parent().find(".submenu").addClass("active");
        }
    });



    $(".desktop_nav_bar__item--expandable .close-button").on('click', function () {
        let active_submenu = $(this).parents(".submenu"),
            pointer = $(".desktop_sub_bar__pointer");
        active_submenu.removeClass("active");
        active_submenu.parent().find('a').removeClass("active");
        pointer.css('left', "-20px");
        $(".desktop_sub_bar").removeClass("active");
    });

    $('.submenu__list--slick').each(function(){
        let $that = $(this);
        $(this).slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            prevArrow: $that.parent().find('.control-slider__item--left'),
            nextArrow: $that.parent().find('.control-slider__item--right'),
            infinite: false,
            arrows: true
        });
    });

}


export function menu() {

    $('.item--has-submenu>a, .item--has-submenu .submenu').hover( function (e) {
        let item = $(this).parent(),
            activeItem = $('.item--has-submenu.active'),
            pointer = $(".desktop_sub_bar__pointer"),
            bottomBar = $(".desktop_sub_bar"),
            checkItem = item.hasClass('active');

        pointer.css('left', ($(this).offset().left + $(this).outerWidth() / 2) + "px");
        activeItem.not(item).removeClass('active');
        item.toggleClass('active');

        if (!checkItem) {
            bottomBar.addClass("active");
        } else {
            pointer.css('left', "-20px");
            bottomBar.removeClass("active");
        }

    });

    $(document).on("click", function (e) {
        if($(e.target).is(".item--has-submenu>a, .submenu,.item-mobile--has-submenu>a, .submenu .item a") === false){
            $(".desktop_sub_bar__pointer").css('left', "-20px");
            $(".desktop_sub_bar").removeClass("active");
            $('.item--has-submenu.active').removeClass('active');
            $('.item-mobile .submenu').removeClass('active').stop().fadeOut(500);
        }
    });

    $('.item-mobile--has-submenu>a').on('click', function (e) {
        e.preventDefault();
        let item = $(this).next('.submenu'),
            activeItem = $('.item-mobile--has-submenu>.submenu');
        activeItem.not(item).removeClass('active').stop().fadeOut(500);


        if(item.hasClass('active')) {
            item.removeClass('active').stop().fadeOut(500);
        }else{
            item.addClass('active').stop().fadeIn(500);
        }

    });

    $('.open-modal').on('click', function(e) {
        e.preventDefault();
        $('.menu-main-mobile-modal').addClass('active');
        $('body').addClass('body-scroll-off');
    });
    
    $('.open-trade-modal').on('click', function(e) {
        e.preventDefault();
        $('.trade-mobile-modal').addClass('active');
        $('body').addClass('body-scroll-off');
    });
    
    $('.close-mobile-modal').on('click', function() {
        $('.menu-mobile-modal').removeClass('active');
        $('body').removeClass('body-scroll-off');
    });


}